import { rem } from './../functions/units';
import baseUnits from './../visid/base-unit';
var typographyRootSize = baseUnits.rootSizeUnit; /** Number (16) */

var typography = {
  // Base Typography
  typographyRootSize: typographyRootSize,
  typographyFontWeightThin: 'lighter',
  typographyFontWeightLight: 300,
  typographyFontWeightNormal: 'normal',
  typographyFontWeightSemiBold: 500,
  typographyFontWeightBold: 700,
  typographyRootFontWeight: 'normal',
  typographyRootFontWeightBold: 700,
  typographyRootSpacingUnit: baseUnits.rootSizeUnit,
  typographyParagraphBottomMargin: rem(baseUnits.rootSizeUnit),
  typographyLineHeightMi: 1,
  typographyLineHeightXs: 1.125,
  typographyLineHeightSm: 1.25,
  typographyLineHeightMd: 1.5,
  typographyLineHeightLg: 1.75,
  typographyLetterSpacingMd: 'normal',
  typographyLetterSpacingSm: rem(-0.1),
  typographyLetterSpacingXs: rem(-0.2),
  // Base
  typographyBase: rem(typographyRootSize),
  // Body
  typographyBodyMi: rem(typographyRootSize * 0.688) /** 11 */,
  typographyBodyXs: rem(typographyRootSize * 0.75) /** 12 */,
  typographyBodySm: rem(typographyRootSize * 0.875) /** 14 */,
  typographyBodyMd: rem(typographyRootSize) /** 16 */,
  typographyBodyLg: rem(typographyRootSize * 1.125) /** 18 */,

  // Headings
  typographyHeadingXs: rem(typographyRootSize * 1.125) /** 18 **/,
  typographyHeadingSm: rem(typographyRootSize * 1.25) /** 20 **/,
  typographyHeadingMd: rem(typographyRootSize * 1.5) /** 24 **/,
  typographyHeadingLg: rem(typographyRootSize * 1.75) /** 28 **/,
  typographyHeadingXl: rem(typographyRootSize * 2) /** 32 **/,
  typographyHeadingGi: rem(typographyRootSize * 2.25) /** 36 **/,

  // display
  typographyDisplayXs: rem(typographyRootSize * 2.625) /** 42 **/,
  typographyDisplaySm: rem(typographyRootSize * 3) /** 48 **/,
  typographyDisplayMd: rem(typographyRootSize * 3.5) /** 56 **/,
  typographyDisplayLg: rem(typographyRootSize * 3.75) /** 60 **/,
  typographyDisplayXl: rem(typographyRootSize * 4) /** 64 **/,
  typographyDisplayGi: rem(typographyRootSize * 4.5) /** 72 **/,

  typographyHeadingXsWeight: 100,
  typographyHeadingSmWeight: 300,
  typographyHeadingMdWeight: 500,
  typographyHeadingLgWeight: 700,
  typographyHeadingXlWeight: 900
};
export default typography;